export default __webpack_public_path__ + "static/bg-yellow-faf4597f9f5014a280f8aa39b5953b95.jpg";